<div class="grid claims-list" *ngIf="claims?.length; else noClaims">
  <ng-container *ngFor="let claim of claims">
    <app-entity-card
      class="cell cell-large-col-span-12"
      [iconName]="getIcon(claim.product_type)"
      [title]="getClaimType(claim.product_type, claim.event_type)"
      [subtitle]="label"
    >
      <open-badge *ngIf="configData && configData.types" [label]="configData.types.claimStates[claim.state].customer.label" [variant]="getClaimStatus(claim.state)"></open-badge>
    </app-entity-card>
  </ng-container>
</div>

<ng-template #noClaims>
  <div class="flex flex-justify-center padding-big">
    <h4>No claims</h4>
  </div>
</ng-template>
